 export const RollcallAttaedanceInOutReport = [
    {
      "s_no": 1,
      "CardId": 1,
      "UserName": "Baji",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "10:04:55",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:00",
      "MornLate": "00:04",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    },
    {
      "s_no": 2,
      "CardId": 2,
      "UserName": "ali",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "10:24:33",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:00",
      "MornLate": "00:24",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    },
    {
      "s_no": 3,
      "CardId": 3,
      "UserName": "rajesh",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "10:48:22",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:00",
      "MornLate": "00:48",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    },
    {
      "s_no": 4,
      "CardId": 4,
      "UserName": "Babji",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "09:59:14",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:01",
      "MornLate": "00:00",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    },
    {
      "s_no": 5,
      "CardId": 6,
      "UserName": "Chandu",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "10:11:28",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:00",
      "MornLate": "00:11",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    },
    {
      "s_no": 6,
      "CardId": 8,
      "UserName": "Das",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "10:04:52",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:00",
      "MornLate": "00:04",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    },
    {
      "s_no": 7,
      "CardId": 12,
      "UserName": "Haleema",
      "Date": "3/25/2025 12:00:00 AM",
      "InTime1": "10:26:31",
      "OutTime1": "",
      "InTime2": "",
      "OutTime2": "",
      "MornEarly": "00:00",
      "MornLate": "00:26",
      "EveEarly": "00:00",
      "EveLate": "00:00"
    }
  ]
  